var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { LinkList } from './LinkList';
import styled from 'styled-components';
import { AnimatePresence, m } from 'framer-motion';
import { cssSpacing } from '@spotify-internal/encore-web/core';
import { MotionWrapper } from '../../MotionWrapper';
var Wrapper = styled(m.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n"], ["\n  width: 100%;\n  display: flex;\n"])));
var LinkListWrapper = styled(LinkList)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-block: ", ";\n  overflow: hidden;\n"], ["\n  padding-block: ", ";\n  overflow: hidden;\n"])), cssSpacing('looser-3'));
export var MobileLinkMenu = function (_a) {
    var links = _a.links, isOpen = _a.isOpen;
    return (React.createElement(MotionWrapper, null,
        React.createElement(AnimatePresence, null, isOpen && (React.createElement(Wrapper, { "data-testid": "animated-menu", initial: { height: 0, opacity: 0 }, animate: { height: 'auto', opacity: 1 }, exit: { height: 0, opacity: 0 }, transition: {
                duration: 0.5,
                ease: [0.5, 0, 0, 1]
            } },
            React.createElement(LinkListWrapper, { links: links }))))));
};
var templateObject_1, templateObject_2;
